'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsonwebtoken = require('jsonwebtoken');

var _jsonwebtoken2 = _interopRequireDefault(_jsonwebtoken);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAuthToken = function getAuthToken() {
  var user = {
    app_metadata: {
      roles: ['admin'],
      dyzio: {
        u_id: 'c9b88fbf-e8c7-49e5-9641-fab85fd0b863',
        name: 'Laurie Bantin',
        email: 'laurie@dyzio.co',
        o_id: '6c1b653e-d704-4055-acc7-79f280f523f6'
      }
    }
  };

  var options = {
    audience: 'MxuEZkaXquZnlJeL9oE8QhyQzhMtjfTp',
    issuer: 'dyzio.eu.auth0.com',
    expiresIn: 10000
  };

  return _jsonwebtoken2.default.sign(user, Buffer.from('WXRhOW5rQ3ExVFJXejBmSFVmNFB2Q0xFeUJFcTJHdkJQMGdGUnFwdHJXMVYwUktDWU1mYlRkMnNCcmFrVXZ4Vw==', 'base64'), options);
};

exports.default = getAuthToken;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/utils/auth-token.js
 ** module id = 2601
 ** module chunks = 0
 **/